import useAppStore from "@hooks/useAppStore";
import { supportedLanguages } from "@i18n/i18n";
import { createTheme, ThemeProvider } from "@mui/material";
import Box from "@mui/material/Box";
import * as locales from "@mui/material/locale";
import Typography from "@mui/material/Typography";
import { useMemo } from "react";

const Footer = ({ message }: { message: string }) => {
  const appStore = useAppStore();

  const darkTheme = useMemo(() => {
    const muiLocale = supportedLanguages.find((l) => l.locales.includes(appStore.language))?.mui || "enUS";
    // @ts-ignore No index signature with a parameter of type 'string' was found on type 'typeof
    const locale = locales[muiLocale];

    return createTheme(
      {
        palette: {
          mode: appStore.colorMode === "light" ? "dark" : "light",
        },
        components: {
          MuiTypography: {
            styleOverrides: {
              root: {
                "&.MuiTypography-root": {
                  fontFamily: "ArtifaktElement, sans-serif",
                },
              },
            },
          },
        },
      },
      locale,
    );
  }, [appStore.colorMode, appStore.language]);

  return (
    <ThemeProvider theme={darkTheme}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderTop: 1,
          borderColor: darkTheme.palette.divider,
        }}
      >
        <Typography variant="caption" sx={{ padding: "8px" }}>
          {message}
        </Typography>
      </Box>
    </ThemeProvider>
  );
};

export default Footer;
